import React from 'react';
import { Clock, Layers, BarChart3, Zap } from 'lucide-react';

export const ProblemSection = () => {
  const problems = [
    { icon: Clock, text: 'Lange køer ved barer og boder' },
    { icon: Layers, text: 'Flere systemer der ikke taler sammen' },
    { icon: BarChart3, text: 'Manglende overblik over salg' },
    { icon: Zap, text: 'Pres på personale og drift i peak-perioder' },
  ];

  return (
    <section data-testid="problem-section" className="py-24 md:py-32">
      <div className="container-custom">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground mb-5">
              Events bliver hurtigt komplekse
            </h2>
            <p className="text-lg text-body-text mb-8">
              Når mange mennesker samles, opstår der hurtigt udfordringer:
            </p>
            <div className="space-y-5">
              {problems.map((problem, index) => {
                const Icon = problem.icon;
                return (
                  <div key={index} className="flex items-center gap-4">
                    <div className="w-10 h-10 rounded-lg bg-accent-blue/10 flex items-center justify-center flex-shrink-0">
                      <Icon className="w-5 h-5 text-accent-blue" />
                    </div>
                    <span className="text-body-text">{problem.text}</span>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="relative">
            <div className="rounded-2xl overflow-hidden shadow-large">
              <img
                src="https://images.unsplash.com/photo-1718634353354-fa2fc07e3080?w=800&q=80"
                alt="Publikum ved festival"
                className="w-full h-auto object-cover aspect-[4/3]"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
